// extracted by mini-css-extract-plugin
export var contentBody = "_49-9";
export var headerImage = "_49-2";
export var imageButton = "_49-7";
export var imageButtonIcon = "_49-8";
export var imageHeader = "_49-4";
export var imageHeaderText = "_49-5";
export var imageOverlay = "_49-3";
export var imageTitle = "_49-6";
export var imageWrapper = "_49-1";
export var taskList = "_49-a";
export var widget = "_49-0";